import React, { useState, useEffect } from 'react';
import axios from 'axios';

import LayerTemplate from 'components/EcoEnvironmentalSurvey/LeafletMap/LayerTemplate';

import { contentList } from 'data/eco-environmental-survey';

import { useMacrobenthosContext } from 'context/MacrobenthosContext';

function MacrobenthosLayer(props) {
  const { currentPath, mapIcon } = props;
  const {
    sites,
    activeSite,
    setActiveSite,
    activeSiteData,
    getSiteMacrobenthosSeries,
    getSiteList,
    getSiteContent,
    siteMacrobenthosSeries,
  } = useMacrobenthosContext();

  const isNoActiveSite = activeSite === '';
  const hasSedimentData = activeSiteData.id !== 0;
  const hasMacrobenthosData = siteMacrobenthosSeries.length > 0;

  const canShowContent = (id) => {
    if (id === 'macrobenthos') {
      return hasMacrobenthosData;
    }

    return hasSedimentData;
  };

  const handleContent = (data, id) => {
    if (id === 'macrobenthos') {
      const latestSeries =
        siteMacrobenthosSeries[siteMacrobenthosSeries.length - 1];
      const matchSpeciesNames =
        siteMacrobenthosSeries.find(
          (v) =>
            String(v.year) === String(activeSiteData.year) &&
            String(v.month) === String(activeSiteData.month)
        )?.speciesNames || latestSeries?.speciesNames;

      return matchSpeciesNames && matchSpeciesNames?.length !== 0 ? (
        matchSpeciesNames.map((v, i) => {
          const isLastItem = i === matchSpeciesNames.length - 1;
          return (
            <span key={i}>
              {v}
              {!isLastItem && '、'}
            </span>
          );
        })
      ) : (
        <span>-</span>
      );
    }

    if (data[id] !== null) {
      const matchUnit = contentList.macrobenthos.find((v) => v.id === id).unit;
      return `${data[id]} ${matchUnit ? matchUnit : ''}`;
    } else {
      return '-';
    }
  };

  useEffect(() => {
    getSiteList();
  }, []);

  useEffect(() => {
    if (!isNoActiveSite) {
      getSiteContent();
      getSiteMacrobenthosSeries();
    }
  }, [activeSite]);

  return (
    <>
      <LayerTemplate
        baseLayer=""
        layerName={{ title: '底棲生物觀測點位', en: 'macrobenthos' }}
        currentPath={currentPath}
        siteList={sites}
        contentList={contentList.macrobenthos}
        handleContent={handleContent}
        mapIcon={mapIcon}
        activeSite={activeSite}
        setActiveSite={setActiveSite}
        activeSiteData={activeSiteData}
        canShowContent={canShowContent}
      />
    </>
  );
}

export default MacrobenthosLayer;
